import React from "react";
import { observer } from "mobx-react";

import { ITags } from "@formant/core/model/ITags";

import { useStores } from "../../context/StoreContext";
import { EditTags } from "./EditTags";

export interface IEditDeviceTagsProps {
    value: ITags;
    small?: boolean;
    className?: string;
    onChange: (value: ITags) => void;
    skipUnusedTags?: boolean;
    allowStar?: boolean;
}

export const EditDeviceTags = observer(function EditDeviceTags(
    props: IEditDeviceTagsProps,
) {
    const { value, skipUnusedTags, allowStar } = props;
    const { deviceStore } = useStores();
    const tags = deviceStore.tags({ enabled: true, type: "default" }) || {};
    const keys = Array.from(
        new Set([
            ...(skipUnusedTags ? [] : Object.keys(value)),
            ...Object.keys(value),
        ]),
    ).sort();

    return (
        <EditTags tags={tags} keys={keys} allowStar={allowStar} {...props} />
    );
});
